const otherPosts = async function( $block ) {
	const { Swiper } = await import( "swiper" );
	await import( "swiper/css/bundle" );
	const { Navigation, Pagination } = await import( "swiper/modules" );
	const $slider = $block.find( ".other-posts__slider" );

	if ( !$slider.length ) { return false; }

	const otherPostsSlider = new Swiper( $slider[0], {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		speed: 1000,
		spaceBetween: 16,
		pagination: {
			el: ".other-posts__pagination",
			type: "bullets",
			clickable: true,
		},
		navigation: {
			nextEl: ".other-posts__next",
			prevEl: ".other-posts__prev",
		},
		breakpoints: {
			1199: {slidesPerView: 4},
			940: {slidesPerView: 3},
			600: {slidesPerView: 2},
		}
	} );

	otherPostsSlider.init();
};
 
themeUtils.loadBlock( otherPosts, "other-posts", ".other-posts" );